import React, {
  Dispatch,
  SetStateAction,
  useContext,
} from 'react';
import classNames from 'classnames';

import {
  Fieldset,
  Toggle,
  DateField,
  ToggleGroup,
} from '@ktag/styleguide/dist/react';

import {
  FormFieldEmail, AppFormField, FormConfigStore, FormUtils,
  FormFieldAHVNumber,
  Validators,
} from 'ewp-common';

import formDataStore from 'stores/formDataStore';

interface Props {
  id?: string;
  className?: string;
  additionalClassNames?: string;
  setAddress?: (val: any) => void;
  setRoute?: Dispatch<SetStateAction<number>>,
  cancel?: () => void,
  errorList?:any
}

const PersonalInfo = (props: Props) => {
  const {
    id,
    className,
    additionalClassNames,
  } = props;

  const {
    state: formConfigState,
  } = useContext(FormConfigStore.FormConfigContext);

  const {
    state: formDataState,
  } = useContext(formDataStore.FormDataContext);

  const configs = formConfigState?.data?.labelsMap;

  let showAhvNumber = false;
  if(process.env.REACT_APP_SHOW_AHV_NUMBER_FIELD == "1"){
    showAhvNumber = true;
  }

  return (
    <div id={id} className={classNames(className, additionalClassNames)}>
      <div className="mt-4">
        <h2>{configs.h2PersonalInfo.labelDisplayName}</h2>
        <Fieldset>
          <ToggleGroup
            name={FormUtils.getFieldName(configs.fieldAnrede)}
            label={configs.fieldAnrede.labelDisplayName}
            required={configs.fieldAnrede.mandatory === 'true'}
            infoText={configs.fieldAnrede.labelDescription}
            horizontal
          >
            <Toggle type="radio" value="Herr" label="Herr" />
            <Toggle type="radio" value="Frau" label="Frau" />
          </ToggleGroup>
          <AppFormField formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY} config={configs.fieldLastname} autoComplete="family-name" />
          <AppFormField formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY} config={configs.fieldFirstname} autoComplete="given-name" />
          {configs?.fieldAhvNumber && showAhvNumber &&
          <FormFieldAHVNumber
            formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
            fieldConfig={configs?.fieldAhvNumber}
            initValue={formDataState.personal.fieldAhvNumber}
          />}
          <DateField
            label={configs.fieldBirthDate.labelDisplayName}
            name={FormUtils.getFieldName(configs.fieldBirthDate)}
            placeholder={configs.fieldBirthDate.labelDescription}
            infoText={configs.fieldBirthDate.labelDescription}
            validate={(e) => Validators.pastDateValidator(e,configs)}
            required
          />
          <AppFormField
            formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
            config={configs.fieldPhone}
            type="tel"
            prefillwith="+41 "
          />
          <FormFieldEmail
            formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
            fieldConfig={configs.fieldEmail}
          />
        </Fieldset>
      </div>
    </div>
  );
};

PersonalInfo.defaultProps = {
  id: '',
  className: 'personalInfo',
  additionalClassNames: '',
};

export default PersonalInfo;
